import { clsx } from 'clsx';
import React from 'react';
import 'src/style/component/alert.scss';

interface IProps {
  message: string;
  className?: string;
}

const Alert: React.FC<IProps> = ({ message, className }) => (
  <div className={clsx('alert', className)} role="alert">
    {message}
  </div>
);

export default Alert;
